<template>
  <div>
    <label class="container-checkbox">
      <p class="checkbox-label">{{ label }}</p>
      <input type="checkbox" v-model="isChecked">
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    id: String,
    label: String,
    initialValue: Boolean,
    newValue: Boolean
  },
  data() {
    return {
      isChecked: !!this.initialValue
    }
  },
  watch: {
    isChecked: {
      handler() {
        this.$emit('value-change', {
          id: this.id,
          label: this.label,
          isChecked: this.isChecked
        });
      }
    },
    newValue: {
      handler(newVal) {
        this.isChecked = newVal;
      }
    }
  }
}
</script>

<style scoped>
/* The container */
.container-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: var(--dark-grey);
}

.container-checkbox:hover {
  color: var(--primary-blue);
}

.container-checkbox p {
  text-align: left;
  margin-left: 10px;
}

/* Hide the browser's default checkbox */
.container-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #ffffff;
  border: 1px solid var(--primary-blue);
}

/* On mouse-over, add a grey background color */
.container-checkbox:hover input ~ .checkmark {
  background-color: #ffffff;
}

/* When the checkbox is checked, add a blue background */
.container-checkbox input:checked ~ .checkmark {
  background-color: var(--primary-blue);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container-checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid #ffffff;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
